import Service from './baseService';
import { getCompanyId, getModelTypeIdAndEntityId } from '../config';

export const getBookingsService = ({ type, startDate, endDate }) => {
    let params = { type, startDate, endDate, ...getModelTypeIdAndEntityId() };
    return Service.get('/customer/bookings', { params });
};

export const getBookingPaymentDetailsService = (id, ts) => {
    return Service.get(`/customer/bookings/payment/${id}`, {
        params: { timeStamp: ts, ...getModelTypeIdAndEntityId() },
    });
};

export const getPublicBookingDriverDetailsService = (id, ts) => {
    return Service.get(`/customer/bookings/driver-details/${id}`, { params: { timeStamp: ts } });
};

export const getBookingDetailsService = (id) => {
    return Service.get(`/customer/bookings/${id}`, { params: { ...getModelTypeIdAndEntityId() } });
};

export const getBookingDiscountsService = (bookingId) => {
    let params = { ...getModelTypeIdAndEntityId() };
    if (bookingId) params.bookingId = bookingId;
    return Service.get(`/customer/bookings/discounts`, { params });
};

export const printSignedBookingService = (bookingId, signedContractId, companyId, user, isLatest = 0) => {
    let params = {
        companyId: companyId ? companyId : getCompanyId(),
        signedContractId,
        isLatest,
        ...getModelTypeIdAndEntityId(),
    };
    if (user) params.user = user;

    return Service.post(`/customer/bookings/get-signedPrint/${bookingId}`, {}, { params, responseType: 'arraybuffer' });
};

export const getBookingConfirmationDetailsService = (bookingId, ts) => {
    return Service.get(`/customer/bookings/confirmation/${bookingId}`, {
        params: { timeStamp: ts, ...getModelTypeIdAndEntityId() },
    });
};

export const getBookingDisclaimersDetailsService = (bookingId, ts) => {
    return Service.get(`/customer/bookings/booking-disclaimer/${bookingId}`, { params: { timeStamp: ts } });
};

export const getBookingVehiclesDetailService = (bookingId, isForPayment) => {
    let params = { isStoreProc: true, ...getModelTypeIdAndEntityId() };

    if (isForPayment) params.isForPayment = isForPayment;
    return Service.get(`/customer/bookings/get-booking-vehicles-details/${bookingId}`, { params });
};

export const getBookingTransactionService = (bookingId) => {
    return Service.get(`/customer/bookings/transaction/${bookingId}`, { params: getModelTypeIdAndEntityId() });
};

export const bookingConfirmation = (bookingId, name) => {
    return Service.patch(`/customer/bookings/booking-confirmation/${bookingId}`, { name });
};

export const applyBookingDiscountCodeService = (bookingId, discountCode, timeStamp) => {
    return Service.post(`/customer/bookings/payment/${bookingId}/apply-discount`, { discountCode, timeStamp });
};
